export default {
  apiKey: 'AIzaSyAET1sDMzVtO2blNBjn17WY6Hz6Tjx57JY',
  authDomain: 'click-em-quick.firebaseapp.com',
  databaseURL: 'https://click-em-quick.firebaseio.com',
  projectId: 'click-em-quick',
  storageBucket: 'click-em-quick.appspot.com',
  messagingSenderId: '363110423160',
  appId: '1:363110423160:web:f4ab093cc4171e049c2b8d',
};
